import React from 'react';
import { ServiceIntroductionSectionProps } from '../../../../../Sections/Services/IntroductionSection/IntroductionSection';
import Container from '../../../../../Common/Container/Container';
import IntroText from '../../../../DefaultTemplate/Components/IntoText/IntroText';
import * as classes from './IntroductionSection.module.scss';
import cn from 'classnames';
import Card from '../../../Components/Card/Card';
import UsersIcon from '../../../../../../assets/icons/inline/users-green.inline.svg';
import BoxIcon from '../../../../../../assets/icons/inline/box-red.inline.svg';
import ClipboardIcon from '../../../../../../assets/icons/inline/clipboard-black.inline.svg';
import DottedList from '../../../../../Common/DottedList/DottedList';
import RoundedSquare from '../../../Components/RoundedSquare/RoundedSquare';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import ModernButton from '../../../Components/ModernButton/ModernButton';

const IntroductionSection = ({
  introText,
  image,
  specialties,
  benefits,
  targetAudience,
  serviceName,
  serviceId,
}: ServiceIntroductionSectionProps) => {
  const { t } = useTranslation();
  return (
    <section className={classes.wrapper}>
      <Container className={classes.infoWrapper}>
        <div className='row' data-aos='fade-in'>
          <div className={cn('col-xl-5 col-lg-6 col-md-12', classes.introWrapper)}>
            <div className={classes.title}>{serviceName}</div>
            <IntroText introText={introText} key={serviceId} />
          </div>
          <div className={'col-xl-6 offset-xl-1 col-lg-6 col-md-12'}>
            <img src={image} alt='' className={classes.image} />
          </div>
        </div>
      </Container>
      <div className={classes.servicesWrapper} data-aos='fade-in'>
        <div className='row'>
          <div className='col-lg-5 offset-lg-1 col-md-4 col-sm-12'>
            <div className={classes.title}>
              {serviceName} {t('services.intoSection.services')}
            </div>
            <div className={classes.buttonWrapper}>
              <ModernButton
                link={{
                  path: t('services.intoSection.getInTouchButton.url'),
                  title: t('services.intoSection.getInTouchButton.title'),
                }}
              >
                {t('services.intoSection.getInTouchButton.label')}
              </ModernButton>
            </div>
          </div>
          <div className='col-lg-6 col-md-8 col-sm-12'>
            <div className='row'>
              <div className={cn('col-sm-12 col-md-6', classes.specialtiesWrapper)}>
                {!!specialties.length && (
                  <Card>
                    <div>
                      <div className={classes.icon}>
                        <UsersIcon />
                      </div>
                      <div className={classes.cardInfo}>
                        <div className={classes.cardTitle}>{t('services.intoSection.specialties')}</div>
                        <div>
                          <DottedList items={specialties} />
                        </div>
                      </div>
                    </div>
                  </Card>
                )}
              </div>
              <div className='col-sm-12 col-md-6'>
                {!!benefits?.length && (
                  <Card>
                    <div className={classes.icon}>
                      <BoxIcon />
                    </div>
                    <div className={classes.cardInfo}>
                      <div className={classes.cardTitle}>{t('services.intoSection.canHelpYouWith')}</div>
                      <div>
                        <DottedList items={benefits} />
                      </div>
                    </div>
                  </Card>
                )}
                <Card>
                  <div className={classes.icon}>
                    <ClipboardIcon />
                  </div>
                  <div className={classes.cardInfo}>
                    <div className={classes.cardTitle}>{t('services.intoSection.providedTo')}</div>
                    <div>
                      <DottedList items={targetAudience} />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.decorationWrapper}>
          <RoundedSquare />
        </div>
      </div>
    </section>
  );
};

export default IntroductionSection;
